import { Inject, Injectable } from "@angular/core";
import saveAs from 'file-saver';
import { Platform } from "ionic-angular";
import { Observable } from "rxjs";
import { FileDownloaderProvider } from "../../providers/file-downloader/file-downloader";
import { LoopBackAuth } from "../../shared/sdk";
import { NestApiProvider } from './../../shared/nestjs/nest-api';
import { ViewAttReportApi } from './../../shared/sdk/services/custom/ViewAttReport';
import { OvtCancelReportApi } from "../../shared/nestjs/gd-only/services/overtime-cancel-report.api";
import { AnalyticsProvider } from "../../providers/analytics/analytics";
import { EventNameAnalytics } from "../../helpers/event-name-analytics";
@Injectable()
export class OvertimeCancelReportBloc {
    constructor(
        @Inject(LoopBackAuth) protected auth: LoopBackAuth,
        private ovtCancelReportApi: OvtCancelReportApi,
        private platform: Platform,
        private fileDownloaderProvider: FileDownloaderProvider,
        private nestApiProvider: NestApiProvider,
        private viewattreportApi: ViewAttReportApi,
        private analyticsProvider: AnalyticsProvider
    ) { }


    downloadExcel(data: any): Observable<any> {
        this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_DOWNLOAD_EXCEL);
        return this.ovtCancelReportApi.downloadExcel(data);
    }

    downloadExcelLB(data): Promise<any> {
        return new Promise(async (resolve, reject) => {
            console.log(data);
            resolve('Download Success')
        })
    }

    generateExcel(data) {
        if (this.platform.is('cordova')) {
            this.fileDownloaderProvider.downloadExcelBlob(data, 'Overtime Cancellation Report')
        } else {
            saveAs(data, 'Overtime Cancellation Report.xlsx')
        }
    }

    downloadPdf(data: any): Observable<any> {
        this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_DOWNLOAD_PDF);
        return this.ovtCancelReportApi.downloadPdf(data);
    }

    generatePdfLB(data): Promise<any> {
        return new Promise(async (resolve, reject) => {
            console.log(data);
            resolve('Download Success')
        })
    }

    generatePdf(data) {
        if (this.platform.is('cordova')) {
            this.fileDownloaderProvider.downloadPdfBlob(data, 'Overtime Cancellation Report')
        } else {
            saveAs(data, 'Overtime Cancellation Report.pdf')
        }
    }

    sendExcel(data): Observable<any> {
        return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
            .mergeMap(isGoPathNewExist => {
                this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_SEND_MAIL);
                if (isGoPathNewExist) {
                    return this.ovtCancelReportApi.sendMailExcel(data)
                } else {
                    data.sendEmail = true;
                    return this.viewattreportApi.download(data);
                }
            })
    }

    sendPdf(data): Observable<any> {
        return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
            .mergeMap(isGoPathNewExist => {
                this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_DOWNLOAD_EXCEL);

                if (isGoPathNewExist) {
                    return this.ovtCancelReportApi.sendMailPdf(data)
                } else {
                    data.sendEmail = true;
                    return this.viewattreportApi.pdfmake(data);
                }
            })
    }

    generatePreview(data): Observable<any> {
        return this.viewattreportApi.pdf2img(data);
    }

    status(): Observable<any> {
        return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
            .mergeMap(isGoPathNewExist => {
                if (isGoPathNewExist) {
                    return this.ovtCancelReportApi.status()
                }
            })
    }
}



// WEBPACK FOOTER //
// ./src/bloc/report/overtime-cancel-report.bloc.ts